import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxFormModule, DxTextBoxModule } from 'devextreme-angular';
import { ContextService } from './services/context.service';
import { DataService } from './services/data.service';
import { WebApiService } from './services/web-api.service';
import { UserSettingsComponent } from './user-settings.component';

@NgModule({
  imports: [CommonModule, DxFormModule, DxTextBoxModule],
  declarations: [UserSettingsComponent],
  exports: [UserSettingsComponent],
  providers: [ContextService, DataService, WebApiService],
})
export class UsersModule {}
